import React from 'react';
import DataTypes from '../../components/Table/dataTypes';
import CreatePpsiButton from '../../components/common/CreatePpsiButton';
import {
  ppiCreateFromExistingRoute,
  ppiCreateFromPublishedPpiRoute,
  ppiCreateRoute,
  ppsiCreateFromPublishedPpsiRoute,
  ppsiCreateRoute
} from '../../routes';
import ButtonGroup from 'components/common/ButtonGroup';
import { FormattedMessage } from 'react-intl';

const formatFormulaCode = (formulaCode, version) => {
  return `${formulaCode.substring(0, 3)} ${formulaCode.substring(
    3,
    7
  )} ${formulaCode.substring(7, formulaCode.length)}\\${version}`;
};

export default {
  PresentationName: {
    name: 'presentationName',
    // dataField: 'presentationName',
    calculateCellValue: (data, { language }) => {
      const presentaionName = data.presentationName;
      return presentaionName[language];
    },
    label: 'Product Name',
    width: 550
  },
  Formula: {
    name: 'formula',
    label: 'iFood Formula',
    // Used for sorting. Improve to consider the composed value.
    // dataField: 'formulaCode',
    calculateCellValue: data => `${data.formulaCode}\\${data.formulaVersion}`,
    width: 125,
    grow: 0,
    shrink: 0
  },
  IfoodID: {
    name: 'ifoodID',
    label: 'iFood ID',
    // Used for sorting. Improve to consider the composed value.
    // dataField: 'formulaCode',
    calculateCellValue: data =>
      formatFormulaCode(data.formulaCode, data.formulaVersion),
    width: 150,
    grow: 0,
    shrink: 0
  },
  ModifyDate: {
    name: 'modifyDate',
    dataField: 'modifyDate',
    dataType: DataTypes.Date,
    label: 'iFood Modify Date',
    searchable: false,
    width: 280,
    grow: 0
  },
  LifeCycleStatus: {
    name: 'lifecycleStatus',
    dataField: 'lifecycleStatus',
    // dataType: DataTypes.Date,
    label: 'Lifecycle Status',
    // searchable: false,
    width: 280
    // grow: 0
  },
  PiaNumber: {
    name: 'piaNumber',
    label: 'PIA Number',
    dataField: 'piaArticleNumber',
    width: 100,
    grow: 0,
    shrink: 0
  },
  CreatePpsi: {
    name: 'createPpsi',
    sortable: false,
    label: '',
    CellValue: ({ rowData }) => (
      <CreatePpsiButton route={ppsiCreateRoute(rowData.data.formulaCode)} />
    ),
    width: 175,
    grow: 0,
    shrink: 0
  },

  CreateAndCopyPpsi: {
    name: 'createAndCopyPpsi',
    label: '',
    calculateCellValue: rowData => {
      if (rowData.ppiItemCode !== undefined) {
        const copyRoute = ppiCreateFromExistingRoute(
          rowData.id,
          rowData.publishedPPIEnrichmentData.id,
          rowData.ppiItemCode === null ? rowData.itemCode : rowData.ppiItemCode
        );
        return (
          <ButtonGroup
            route={copyRoute}
            menuItems={[
              {
                text: <FormattedMessage id="ppi.copyLocalInstruction" />,
                route: ppiCreateFromPublishedPpiRoute(
                  rowData.ppiItemCode === null
                    ? rowData.itemCode
                    : rowData.ppiItemCode,
                  true
                )
              },
              {
                text: <FormattedMessage id="ppi.createInstruction" />,
                route: ppsiCreateRoute(rowData.formulaCode)
              }
            ]}
          >
            <FormattedMessage id="ppi.copyGlobalInstruction" />
          </ButtonGroup>
        );
      }
      return (
        <ButtonGroup
          route={ppsiCreateRoute(rowData.formulaCode)}
          menuItems={[
            {
              text: <FormattedMessage id="ppi.copyLocalInstruction" />,
              route: ppsiCreateFromPublishedPpsiRoute(rowData.formulaCode, true)
            }
          ]}
        >
          <FormattedMessage id="ppi.createInstruction" />
        </ButtonGroup>
      );
    },
    filterable: false,
    sortable: false,
    searchable: false,
    width: 240,
    grow: 0,
    shrink: 0
  }
};
